import { GET_COINS } from '../constants/index';

export function coinDetailAction(coinDetail) {
  return {
    type: GET_COINS,
    payload: coinDetail,
  };
}
